import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink
} from 'react-router-dom';

import Masonry from 'react-masonry-component';
import ScrollToTop from './ScrollToTop.js';

import logo from './images/logo.png';
import Lightbox from 'react-images';

import Gallery from './gallery.js'
import './App.css';
import Mailto from 'react-mailto';

//var ReactGA = require('react-ga');
//ReactGA.initialize('UA-77761835-1');

var imageInfo = {
  "Love": {
    name: "Love",
    images: ["./images/items/DSC00141 - Version 2.JPG", "./images/items/DSC00179 - Version 2.jpg"]
  }, 
  "Leaves": {
    name: "Leaves",
    images: ["./images/items/DSC00209 - Version 2.JPG", "./images/items/DSC00210 - Version 2.JPG", "./images/items/DSC01427.JPG"]
  }, 
  "Tartan": {
    name: "Tartan",
    images: ["./images/items/DSC01350 - Version 2.JPG", "./images/items/DSC01354 - Version 2.JPG", "./images/items/DSC01579 - Version 2.JPG"]
  },
  "Bowls": {
    name: "Bowls",
    images: ["./images/items/DSC01596 - Version 2.JPG", "./images/items/DSC01452 - Version 2.JPG"]
  }, 
  "Animals": {
    name: "Animals",
    images: ["./images/items/DSC01459 - Version 2.JPG"]
  },   
};

var images = [
{id: "0", category: "Love", src: require("./images/items/new/DSC00301 - Version 2.JPG"), size: "120"},
{id: "1", category: "Love", src: require("./images/items/new/DSC01607 - Version 2.jpg"), size: "120"},
{id: "2", category: "Love", src: require("./images/items/new/DSC02054 - Version 2.JPG"), size: "250"},
{id: "3", category: "Love", src: require("./images/items/new/DSC02260 - Version 2.JPG"), size: "120"},
{id: "4", category: "Love", src: require("./images/items/new/IMG_0363 - Version 2.JPG"), size: "120"},
{id: "5", category: "Love", src: require("./images/items/new/IMG_3777.JPG - Version 2.JPG"), size: "120"},
{id: "6", category: "Love", src: require("./images/items/new/IMG_3808.JPG - Version 2.JPG"), size: "120"},
{id: "7", category: "Love", src: require("./images/items/new/IMG_4095 - Version 2.JPG"), size: "120"},
{id: "8", category: "Love", src: require("./images/items/new/IMG_7533.JPG - Version 3.JPG"), size: "120"},
{id: "9", category: "Love", src: require("./images/items/new/P1010307.JPG"), size: "120"},
{id: "10", category: "Love", src: require("./images/items/new/P1010321 - Version 2.JPG"), size: "120"},
{id: "11", category: "Love", src: require("./images/items/new/P1010392 - Version 2.JPG"), size: "250"},
{id: "12", category: "Love", src: require("./images/items/new/photo 1 - Version 2.JPG"), size: "120"},
{id: "13", category: "Love", src: require("./images/items/new/unnamed (1).jpg"), size: "120"},
{id: "14", category: "Love", src: require("./images/items/new/unnamed (10).jpg"), size: "120"},
{id: "15", category: "Love", src: require("./images/items/new/unnamed (11).jpg"), size: "250"},
{id: "16", category: "Love", src: require("./images/items/new/unnamed (12).jpg"), size: "120"},
{id: "17", category: "Love", src: require("./images/items/new/unnamed (13).jpg"), size: "120"},
{id: "18", category: "Love", src: require("./images/items/new/unnamed (2).jpg"), size: "120"},
{id: "19", category: "Love", src: require("./images/items/new/unnamed (3).jpg"), size: "120"},
{id: "20", category: "Love", src: require("./images/items/new/unnamed (4).jpg"), size: "120"},
{id: "21", category: "Love", src: require("./images/items/new/unnamed (5).jpg"), size: "120"},
{id: "22", category: "Love", src: require("./images/items/new/unnamed (6).jpg"), size: "120"},
{id: "23", category: "Love", src: require("./images/items/new/unnamed (7).jpg"), size: "120"},
{id: "24", category: "Love", src: require("./images/items/new/unnamed (8).jpg"), size: "120"},
{id: "25", category: "Love", src: require("./images/items/new/unnamed (9).jpg"), size: "120"},
{id: "26", category: "Love", src: require("./images/items/new/unnamed.jpg"), size: "120"}
]

class Home extends React.Component {

    render () {
      return (
        <div>
          <div className="container">
            <Gallery elements={images} />
          </div>
          
        </div>
      )
    }
}

const Contact = () => (
  <div className="PageHeader">
    <div className="Contact-info">
      <h2>Email</h2>
      <Mailto email="contact@rosamundlyons.com" obfuscate={true}>contact@rosamundlyons.com</Mailto>
      
    </div>
    
    <div className="AfterContacts"></div>
  </div>
)

class ItemViewer extends React.Component {
    constructor(props){
      super(props)
      this.itemInfo = imageInfo[props.match.params.category]
    }

    render () {
      var masonryOptions = {
          transitionDuration: 500,
          gutter: 10,
          itemSelector: '.GalleryItemContainer'
      };
      var childElements = this.itemInfo.images.map(function(element){
         return (
              <div key={element} className="GalleryItemContainer">
                  <img className="GalleryItem" src={require(`${element}`)} width="380" height="380" />
              </div>
          );
      });

      return (<div>
        <h1>{this.itemInfo.name}</h1>
        <Masonry
              className="Gallery" 
              elementType={'div'} // default 'div'
              options={masonryOptions} // default {}
              disableImagesLoaded={false} // default false
              updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
          >
              {childElements}
        </Masonry>
      </div>)
    }
}

class App extends Component {

  constructor(props){
    super(props)
    this.state = {openCloseNavMenu: this.props.openCloseNavMenu}
  }
  getInitialState() {
   return {openCloseNavMenu: this.props.openCloseNavMenu}
  }

  render() {
    return (
      <Router>
        <ScrollToTop>
          <div>
            <div className="Navbar">
              <Link to="/"><img src={logo} className="Navbar-logo" alt="logo" /></Link>

              <div onClick={this.toggleMenuButton.bind(this)} className="Navbar-Menu">
                <a className={this.state.openCloseNavMenu}><span></span></a>
                <ul className="Navbar-links">
                  <li className="Navbar-item"><NavLink to="/contact" activeStyle={{ color: '#ff0000' }}>Contact</NavLink></li>
                </ul>
              </div>
            </div>
            <div className="Content">
              <Route exact path="/" component={Home}/>
              <Route path="/contact" component={Contact}/>
              <Route path="/category/:category" component={ItemViewer}/>
            </div>
            <div className="Footer">
              <p className="Copyright">
                &copy; 2018 Rosamund Lyons. All rights reserved.
              </p>
            </div>
            <div className="AfterFooter"></div>
          </div>
        </ScrollToTop>
      </Router>
    );
  }

  toggleMenuButton() {
      var css = (this.state.openCloseNavMenu === "Navbar-menu-button-closed") ? "Navbar-menu-button-open" : "Navbar-menu-button-closed";
      this.setState({openCloseNavMenu:css});
      var navDropdown = document.getElementsByClassName("Navbar-links");
      navDropdown[0].style.cssText = (css === "Navbar-menu-button-closed") ? 'display:none' : 'display:block !important';
  }
}

App.defaultProps = {
  openCloseNavMenu: "Navbar-menu-button-closed"
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js